<template>
  <!--
    CP-226: Detail body layout. The DOM order is the reading order and the keyboard tab order at
    every width, so nothing is reshuffled with CSS `order` / `display: contents`.
      stacked (< 1024px): ONE column, in this order:
        price card, Itinerary, Price Alert, Itinerary Summary, Sail Dates, Ship details,
        Deck plans, Cruise Route map, Price History, Reviews
      not stacked (>= 1024px): two columns, main (Itinerary ... Reviews) then sidebar
        (price card, Price Alert, Itinerary Summary, Sail Dates), i.e. left column then right column.
    The cards themselves live in CruiseDetail.vue (slots), so their markup and scoped styles are
    unchanged; this component only decides where each one goes.
  -->
  <div class="two-column-layout" :class="{ 'two-column-layout--stacked': stacked }">
    <template v-if="stacked">
      <slot name="booking" />
      <slot name="itinerary" />
      <slot name="alert" />
      <slot name="summary" />
      <slot name="dates" />
      <slot name="ship" />
      <slot name="deck" />
      <slot name="map" />
      <slot name="history" />
      <slot name="reviews" />
    </template>
    <template v-else>
      <div class="main-column">
        <slot name="itinerary" />
        <slot name="ship" />
        <slot name="deck" />
        <slot name="map" />
        <slot name="history" />
        <slot name="reviews" />
      </div>
      <div class="sidebar-column">
        <slot name="booking" />
        <slot name="alert" />
        <slot name="summary" />
        <slot name="dates" />
      </div>
    </template>
  </div>
</template>

<script>
export const STACKED_QUERY = '(max-width: 1023px)';

export default {
  name: 'DetailLayout',
  props: {
    stacked: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
/* Moved here unchanged from CruiseDetail.vue (CP-213): phone is a flex stack; desktop is two columns. */
.two-column-layout {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  margin-top: var(--space-5);
}

.main-column {
  flex: 2;
  min-width: 0;
}

.sidebar-column {
  flex: 1;
  min-width: 0;
}

/* Cards carry their own bottom margin; the extra flex gap doubled it. */
@media (max-width: 1023px) {
  .two-column-layout {
    gap: 0;
    margin-top: 0;
  }
}

@media (min-width: 1024px) {
  .two-column-layout {
    flex-direction: row;
  }
}
</style>
